import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

import { Table, TableBody, TableCell, TableContainer, TablePagination, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import TableHeader from '../Table/Header'
import { rowHeight } from '../Table/constants'

const useStyles = makeStyles({
  container: {
    height: '100%',
    alignSelf: 'start',
  },
  tableContainer: {
    flexGrow: 1,
  },
})

const TableView = ({ data }) => {
  const rowsPerPage = 6
  const styles = useStyles()
  const [page, setPage] = useState(0)
  const tableViewRowHeight = rowHeight / 2
  useEffect(() => setPage(0), [data])

  const handleChangePage = (_event, newPage) => {
    setPage(newPage)
  }
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage)

  return (
    <div className={styles.container}>
      <TableContainer className={styles.tableContainer}>
        <Table aria-label="interested students by location">
          <TableHeader
            columns={[
              { id: 'state', label: 'State' },
              { id: 'interestedStudents', label: 'Students', align: 'right' },
            ]}
            style={{ tableViewRowHeight }}
          />
          <TableBody>
            {data.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((state) => (
              <TableRow
                style={{ height: tableViewRowHeight }}
                key={state.state}
              >
                <TableCell>{state.state}</TableCell>
                <TableCell align="right">{state.count}</TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: tableViewRowHeight * emptyRows }}>
                <TableCell colSpan={2} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[rowsPerPage]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
    </div>
  )
}
TableView.propTypes = {
  data: PropTypes.array.isRequired,
}
export default TableView
